import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import {
  ColumnField,
  PlnTableComponent,
  TableAction,
  TablePagination,
} from "src/app/shared/components/pln-table/pln-table.component";
import { ResponseData } from "src/app/shared/http/api";
import { UmovmeEnvironmentService } from "../umovme-environment.service";

@Component({
  selector: "app-umovme-environment",
  templateUrl: "./umovme-environment.component.html",
  styleUrls: ["./umovme-environment.component.scss"],
})
export class UmovmeEnvironmentComponent implements OnInit {
  subscription = new Subscription();
  goback = "";
  filtersForm: FormGroup;
  responseData: ResponseData;
  displayedColumns: ColumnField[] = [
    {
      value: "id",
      showValue: "ID",
      orderBy: true,
      size: 10,
    },
    {
      value: "name",
      showValue: "Nome",
      orderBy: true,
      size: 20,
    },
    {
      value: "token",
      showValue: "Token",
      orderBy: true,
      size: 40,
    },
    {
      value: "active",
      showValue: "Ativo",
      orderBy: true,
      size: 10,
      type: PlnTableComponent.fieldValue().activeInactive,
    },
  ];
  tablePagination: TablePagination;
  tableActions: TableAction[] = [
    {
      action: "edit",
      icon: "edit",
      routerLink: "/umovme-environment/details",
      tooltip: "Editar",
    },
    {
      action: "delete",
      icon: "delete",
      routerLink: "",
      tooltip: "Excluir",
    },
  ];

  constructor(
    private spinner: NgxSpinnerService,
    private service: UmovmeEnvironmentService,
    private router: Router
  ) {}

  ngOnInit() {
    this.filtersForm = new FormGroup({
      filter: new FormControl(null as string),
    });
    this.filter();
  }

  resetFilters() {
    this.filtersForm.reset();
    this.responseData = null;
    this.search();
  }

  handleFilter(pagination?: TablePagination) {
    this.tablePagination = pagination;
    this.filter();
  }

  handleAction(event: TableAction) {
    switch (event.action) {
      case "edit":
        this.router.navigate([event.routerLink], {
          queryParams: event.queryParams,
        });
        break;
      case "delete":
        Alert.question(Alert.getMessage().question.delete).then(
          async (response) => {
            if (response.value) {
              this.subscription.add(
                this.service.remove(event.data.id).subscribe(
                  () => {
                    this.spinner.hide();
                    Alert.success(Alert.getMessage().success.delete).then(() =>
                      this.filter()
                    );
                  },
                  () => {
                    this.spinner.hide();
                    Alert.error(Alert.getMessage().errors.delete);
                  }
                )
              );
            }
          }
        );
        break;
      default:
        break;
    }
  }
  search() {
    if (this.tablePagination) this.tablePagination.page = 1;
    this.filter();
  }

  filter() {
    this.spinner.show();
    this.subscription.add(
      this.service
        .list({ ...this.filtersForm.value, ...this.tablePagination })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.responseData = res;
          },
          (err) => {
            this.spinner.hide();
            this.responseData = null;
            Alert.error(Alert.getMessage().errors.emptySearch);
          }
        )
    );
  }
}
